import type { ResolveTrayScaleNotice } from "./types";

const RENDERED_PAGE_INDEX = 0;

// Two revisions of one drawing calibrate to the same scale; a wider gap means
// the metres on each side were measured against a different ruler.
const SCALE_RELATIVE_EPSILON = 0.02;

export const resolveTrayScaleNotice: ResolveTrayScaleNotice = ({
  beforePlan,
  afterPlan,
}) => {
  if (beforePlan === null || afterPlan === null) return null;

  const beforeScale =
    beforePlan.metersPerPdfPointByPageIndex.get(RENDERED_PAGE_INDEX) ?? 0;
  const afterScale =
    afterPlan.metersPerPdfPointByPageIndex.get(RENDERED_PAGE_INDEX) ?? 0;

  // 0 means uncalibrated, so that side's lengths never got a scale applied.
  if (beforeScale <= 0 || afterScale <= 0) {
    return { kind: "missingScale", differencePercent: 0 };
  }

  const largestScale = Math.max(beforeScale, afterScale);
  const differenceRatio = Math.abs(afterScale - beforeScale) / largestScale;
  if (differenceRatio <= SCALE_RELATIVE_EPSILON) return null;

  return {
    kind: "differentScales",
    differencePercent: Math.round(differenceRatio * 100),
  };
};
